export default __webpack_public_path__ + "static/coin_green-576bf8897a694d9bd319b39a9a52f1ad.png";